<ul class="tree">
  <li>
    <details open>
      <summary>Reports</summary>
      <ul>
        <ng-template #recursiveList let-viewedFileStructureArray>
          <li *ngFor="let item of viewedFileStructureArray">

            <details *ngIf="item.value != null">
              <summary>
                <img src="assets/images/icons8-file-folder-48.png" alt="folder icon" width="20px">
                {{item.name}}
              </summary>
              <ul>
                <ng-container *ngTemplateOutlet="recursiveList; context:{ 
                  $implicit: item.value
                }"></ng-container>
              </ul>
            </details>

            <div class="file-line" *ngIf="item.value == null">
              <span class="cursorpointer" (click)="clickFile(item.folderPath, item.name)">
                {{item.name}}
              </span>
              <div class="action">
                <span class="date" *ngIf="item.created">
                  {{ item.created | date }}
                </span>
                <fa-icon [icon]="['far', 'eye']" size="lg" [styles]="{'stroke': 'orange', 'color': 'orange'}" class="cursorpointer" (click)="clickFile(item.folderPath, item.name)"></fa-icon>
              </div>
            </div>
          </li>
        </ng-template>
        <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: viewedFileStructureArray }"></ng-container>
      </ul>
    </details>
  </li>
</ul>
